<template lang="pug">
.dawn-tab-nav-wrapper
  .dawn-tab-nav
    ul(:class='{ "even-spaced": workflow }')
      li(v-for='tab in tabs'
        :class='{ "is-active text-color line-color": tab.isActive, "is-completed text-color line-color": tab.isCompleted }'
        @click='selectTab(tab)'
        )
        a(:href='tab.href')
          span.tab-icon-wrapper(v-if='tab.icon')
            i(:class='[{ "complete": tab.isCompleted }, tab.iconClass ]')
          span.tab-title-wrapper {{tab.title}}
  .dawn-tab-content
    slot
</template>

<script>

import EdTab from '@/core/components/edTabNav/edTab.vue'

export default {
  name: 'ed-tab-nav',

  components: {
    'ed-tab': EdTab
  },

  props: {
    workflow: { type: Boolean, default: false }
  },

  data() {
    return {
      tabs: []
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    // go to active tab
    this.goToTab()
    this.goToActiveTab()
  },

  methods: {
    goToTab() {
      var tabHash = this.$route.hash
      this.tabs.forEach(tab => tab.section === tabHash && this.selectTab(tab))
    },

    selectTab(activeTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.href === activeTab.href)
      })
    },

    goToActiveTab() {
      this.tabs.forEach(tab => {
        if (tab.isActive) {
          this.$router.replace(tab.section)
          return
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-tab-nav-wrapper {
  margin-left: -15px;
  margin-right: -15px;
}

.uniform {
  li {
    width: 6rem;
    text-align: center;
    height: 7rem;
    vertical-align: top;

    .tab-title-wrapper {
      display: block;
      position: absolute;
      bottom: .5rem;
      left: 0;
      right: 0;
      line-height: 1.1;
    }
  }
}
$tid: unique_id();
.dawn-tab-nav {
  border-bottom: $border;
  border-color: $background;

  ul {
    display: inline-block;
    list-style: none;
    padding-left: .75rem;
    padding-right: .75rem;
    margin-bottom: 1rem;
    width: 100%;
    padding-bottom: .15rem;
    border-bottom: $border-width-default solid $background-light;

    &.even-spaced {
      display: table;

      li {
        display: table-cell;
        .uniform & .tab-title-wrapper {
          padding-left: 2rem;
          padding-right: 2rem;
          &:after {
            // content: quote($tid);
          }
        }
      }
    }

    li {
      position: relative;
      display: inline-block;
      margin: .5rem 2.5rem 0rem 0rem;
      padding-bottom: .3em;
      font-weight: $font-weight-bold;
      border-bottom: .2rem solid;
      border-color: $background-light;
      transition: all .2s ease-in-out;

      &:hover {
        cursor: pointer;
      }

      .tab-icon-wrapper {
        display: block;
        font-size: 2.75rem;
        text-align: center;
        color: $background-light;
        transition: all .2s ease-in-out;
      }

      a {
        color: $background-light;
        text-decoration: none;
        transition: all .2s ease-in-out;
      }

      &.is-completed.is-completed {
        border-color: $border;

        .tab-icon-wrapper {
          color: $border;
        }

        a {
          color: $border;
        }
      }

      &.is-active, &:hover {
        border-color: $tertiary-01;

        .tab-icon-wrapper {
          color: $ink;
        }

        a {
          color: $primary-04;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?2541d402